import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-mentor-student-course',
  templateUrl: './mentor-student-course.component.html',
  styleUrls: ['./mentor-student-course.component.scss']
})
export class MentorStudentCourseComponent implements OnInit {
  values: any[];
  spinner: boolean;
  tableshow: boolean;
   student: any = JSON.parse(localStorage.getItem('login_user_details'));
   permanent_token:any=JSON.parse(localStorage.getItem('permanent_token'));

  // enrolledCourses: any[];

  constructor(private fb: FormBuilder, private ApiService: ApiServiceService, private router: Router,
    private spinnerService: NgxSpinnerService,) {
  
  }
  dtOptions: DataTables.Settings = {};
  ngOnInit(): void {
    this.handleBackButtonForModal();

    this.spinnerService.show(); // Show spinner while loading

    this.ApiService.getAllCourses().subscribe(
      (data) => {
        console.log('Fetched courses:', data);
        this.values = data; // Assuming the API returns an object with a 'course' array
        console.log('Total courses:', this.values.length);
        this.tableshow=true;
        this.spinnerService.hide(); // Hide spinner when done
      },
      (error) => {
        console.error('Error fetching courses:', error);
        this.spinnerService.hide(); // Hide spinner on error
      }
    );

    // this.ApiService.getEnrolledCourses(this.student.id).subscribe(
    //   (response) => {
    //     if (response.status === 'success') {
    //       this.enrolledCourses = response.courses;
    //       console.log('Enrolled Courses:', this.enrolledCourses);
    //     } else {
    //       console.error('Error fetching enrolled courses:', response.message);
    //     }
    //   },
    //   (error) => {
    //     console.error('API error:', error);
    //   }
    // );
    
    this.dtOptions = {
      pagingType: 'full_numbers'
    };
  }
  ngAfterViewInit(): void {
    ($('#courseTable') as any).DataTable();
  }

  isCourseCompleted(courseDate: string): boolean {
  const currentDate = new Date().setHours(0, 0, 0, 0); // Get the current date without time
  const courseDateOnly = new Date(courseDate).setHours(0, 0, 0, 0); // Get the course date without time
  return courseDateOnly < currentDate; // Return true if the course date is in the past
}


  enroll(coursedata: any) {
      console.log(coursedata);
      const student_id = this.student.id;
  
      // Combine course details and student_id into a single object
      const enrollmentData = {
          ...coursedata,
          student_id: student_id,
          permanent_token:this.permanent_token,
      };
  
      // Call the service method to send the data to the backend
      this.ApiService.studentEnrolledMentorCourse(enrollmentData).subscribe(
          (response: any) => {
              console.log('Enrollment response', response);
              
              if (response.status === 'success') {
                  Swal.fire({
                      icon: 'success',
                      title: 'Enrollment Successful',
                      text: response.message,
                      confirmButtonText: 'OK'
                  });
              } else if (response.status === 'error' && response.message === 'Student is already enrolled in this course') {
                  Swal.fire({
                      icon: 'info',
                      title: 'Already Enrolled',
                      text: 'You are already enrolled in this course.',
                      confirmButtonText: 'OK'
                  });
              } else {
                  Swal.fire({
                      icon: 'error',
                      title: 'Enrollment Failed',
                      text: response.message,
                      confirmButtonText: 'OK'
                  });
              }
          },
          (error: any) => {
              console.error('Enrollment failed', error);
              Swal.fire({
                  icon: 'error',
                  title: 'Enrollment Failed',
                  text: 'There was an issue with your enrollment. Please try again.',
                  confirmButtonText: 'OK'
              });
          }
      );
  }
  

  handleBackButtonForModal() {
    // Push initial state to history
    history.pushState(null, '', window.location.href);
  
    window.onpopstate = () => {
      const modal = document.querySelector('.modal.show') as HTMLElement;
      if (modal) {
        // Find the close button inside the modal and trigger a click event on it
        const closeButton = modal.querySelector('.close') as HTMLElement;
        if (closeButton) {
          closeButton.click();
        }
  
        // Prevent default back navigation
        history.pushState(null, '', window.location.href);
      } else {
        // Allow back navigation as usual if modal is not open
        this.router.navigate(['previous-page']); // Replace 'previous-page' with the actual route you want to navigate to
      }
    };
  }
  ngOnDestroy(): void {
    // Cleanup event listener to avoid memory leaks
    window.onpopstate = null;
  }



  

}
